var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 22.9688C7.48334 22.9688 7.08984 22.5753 7.08984 22.0898V8.02734C7.08984 7.54154 6.69674 7.14844 6.21094 7.14844H4.45312C3.96732 7.14844 3.57422 7.54154 3.57422 8.02734V22.0898C3.57422 22.5753 3.18072 22.9688 2.69531 22.9688C2.20951 22.9688 1.81641 23.3619 1.81641 23.8477V27.3633C1.81641 27.8491 2.20951 28.2422 2.69531 28.2422H7.96875C8.45455 28.2422 8.84766 27.8491 8.84766 27.3633V23.8477C8.84766 23.3619 8.45455 22.9688 7.96875 22.9688ZM27.3047 22.9688C26.8193 22.9688 26.4258 22.5753 26.4258 22.0898V8.02734C26.4258 7.54154 26.0327 7.14844 25.5469 7.14844H23.7891C23.3033 7.14844 22.9102 7.54154 22.9102 8.02734V22.0898C22.9102 22.5753 22.5167 22.9688 22.0312 22.9688C21.5454 22.9688 21.1523 23.3619 21.1523 23.8477V27.3633C21.1523 27.8491 21.5454 28.2422 22.0312 28.2422H27.3047C27.7905 28.2422 28.1836 27.8491 28.1836 27.3633V23.8477C28.1836 23.3619 27.7905 22.9688 27.3047 22.9688Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 10.699C14.5228 10.699 14.1296 11.0922 14.1296 11.578V12.5516C13.1072 12.9145 12.3684 13.882 12.3684 15.0275C12.3684 16.4814 13.5512 17.6642 15.0051 17.6642C15.4892 17.6642 15.884 18.0582 15.884 18.5431C15.884 19.2641 14.89 19.6709 14.3854 19.1654C14.0421 18.8203 13.4842 18.8221 13.1409 19.1637C12.7976 19.5062 12.7976 20.0632 13.1392 20.4065C13.4202 20.6881 13.7569 20.889 14.1211 21.0186V22.0896C14.1211 22.5754 14.5142 22.9685 15 22.9685C15.4858 22.9685 15.8789 22.5754 15.8789 22.0896V21.0195C16.9023 20.657 17.6419 19.6893 17.6419 18.5431C17.6419 17.0892 16.4591 15.9064 15.0052 15.9064C14.5211 15.9064 14.1263 15.5124 14.1263 15.0275C14.1263 14.3074 15.1219 13.8988 15.6248 14.4052C15.9681 14.7503 16.5261 14.7485 16.8694 14.4069C17.2127 14.0644 17.2127 13.5074 16.8711 13.1641C16.5896 12.8821 16.2521 12.6811 15.8875 12.5515V11.578C15.8875 11.0922 15.4944 10.699 15.0086 10.699ZM29.334 3.65918L15.2129 0.0267822C15.0721 -0.00925293 14.9279 -0.00925293 14.7871 0.0267822L0.666035 3.65918C0.274687 3.75704 0 4.10807 0 4.51149V8.02711C0 8.51291 0.393105 8.90602 0.878906 8.90602H29.1211C29.6069 8.90602 30 8.51291 30 8.02711V4.51149C30 4.10807 29.7253 3.75704 29.334 3.65918ZM29.1211 26.4841H0.878906C0.393105 26.4841 0 26.8773 0 27.3631V29.1209C0 29.6067 0.393105 29.9998 0.878906 29.9998H29.1211C29.6069 29.9998 30 29.6067 30 29.1209V27.3631C30 26.8773 29.6069 26.4841 29.1211 26.4841Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: -8.18359,
    y: 7.14844,
    width: 46.3672,
    height: 41.0938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.167334,
    y1: -14.3672,
    x2: 33.9479,
    y2: -12.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15,
    y1: 29.9998,
    x2: 15,
    y2: -0.000229836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#379DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.f6b165cde4925845f3ad5dbd1f2c410c.svg";
export { ForwardRef as ReactComponent };